//react...
import React from "react";

import "./Examinations.styles.css";

const RezaHeydari = () => {
  return (
    <div className="examination-container">
      <div className="box">
        <div className="name"> Mr. reza Heydari </div>

        <div className="score"> score:72 / 100 </div>
      </div>
    </div>
  );
};

export default RezaHeydari;
